<template>
  <div id="Notice">

    <Head @isLoginOpen="isLoginOpen" />
    <Login @isLoginOpen="isLoginOpen" v-if="isLogin" />
    <div class="ban">
      <div class="warp_con">
        <div class="title">通知公告</div>
      </div>
    </div>
    <div class="main">
      <ul>
        <li v-for="(item, index) in list" :key="index" @click="seeShare(index, list[index].ID)">
          <div class="box-left">
            <span>{{ item.Date.split("-")[2] }}/</span>
            {{ item.Date.split("-")[1] }}
            <br />
            {{ item.Date.split("-")[0] }}
          </div>
          <router-link :to="`/Hotspot/HotDetails?newsID=${item.ID
            }`" target="_blank" class="box-right">
            <div>
              <b>
                <!-- <span v-if="item.FileCode" @click="seeShare(index)" class="ysj">{{item.FileCode}}</span> -->
                <p ref="fontColor">{{ item.Title }}</p>
              </b>
              <span class="conn">
                {{ item.Summary }}
                <span>[点击查看]</span>
              </span>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <!-- <Page /> -->
    <el-pagination style="text-align: right;height: 0.45rem;" v-if="list.length > 0" @current-change="CurrentChange1"
      @size-change="handleSizeChange1" :current-page="Page1" :page-size="PageSize1" :page-sizes="[10, 20, 30]"
      layout="total,sizes, prev, pager, next, jumper" :total="total1"></el-pagination>
    <RightNav />
    <Foot />
  </div>
</template>

<script>
import Head from "../components/Head";
import Foot from "../components/Foot";
// import Page from "../components/Page";
import Login from "../components/Login";
import RightNav from "../components/RightNav";
export default {
  data() {
    return {
      total1: 0,
      Page1: 1,
      PageSize1: 10,
      list: [],
      isLogin: false
    };
  },
  components: {
    Head,
    Foot,
    // Page,
    Login,
    RightNav
  },
  mounted() {
    this.inform();
  },
  methods: {
    CurrentChange1(val) {
      this.Page1 = val;
      this.inform();
    },
    handleSizeChange1(val) {
      this.PageSize1 = val;
      this.inform();
    },
    isLoginOpen(e) {
      this.isLogin = e;
    },
    async inform() {
      let _this = this;
      await _this.$axios
        .post(
          `information/index?Type=4&status=0&page=${this.Page1}&num=${this.PageSize1}`
        )
        .then(res => {
          console.log(res);
          if (res.data.code == 10000) {
            console.log(res.data.data.list);
            _this.total1 = res.data.data.total_num;
            _this.list = res.data.data.list;
          }
        });
      await _this.$axios
        .post(
          `information/index?Type=5&status=0&page=${this.Page1}&num=${this.PageSize1}`
        )
        .then(res => {
          // console.log(res.data.data.list);
          _this.list.concat(res.data.data.list);
          console.log(_this.list);
        });
    },
    seeShare(i, id) {
      this.$axios.post("information/clicknums?ID=" + id);
      this.$refs.fontColor[i].style.color = "orange";
    }
  }
};
</script>

<style lang="less" scoped>
#Notice {
  width: 100%;
  min-width: 1000px;
  position: relative;

  .ban {
    img {
      position: absolute;
      top: 1.7rem;
      width: 100%;
      height: 2.3rem;
    }

    .warp_con {
      width: 3.2rem;
      height: 1.2rem;
      position: absolute;
      top: 5rem;
      left: 42%;
      line-height: 1rem;
      text-align: center;

      .title {
        font-size: 0.4rem;
        color: #0158b1;
        font-weight: 700;
      }
    }
  }

  .main {
    width: 100%;
    padding: 0 2rem;
    margin-top: 1.4rem;

    li {
      padding: 0.42rem 0;
      border-bottom: 1px solid #ddd;
    }

    li:nth-of-type(1) {
      padding-top: 0.6rem;
      // border-top: 1px solid #ddd;
    }

    li::after {
      content: "";
      display: block;
      clear: both;
    }

    .box-left {
      width: 8%;
      color: #666;
      color: #fff;
      font-size: 0.2rem;
      background: #147de5;
      padding: 0.37rem 0 0.37rem 0.34rem;
      box-sizing: content-box;
      // text-align: center;
      float: left;

      span {
        // color: #0158b1;
        font-size: 0.4rem;
      }
    }

    a:hover {
      color: #3f6bc2;
    }

    .box-right {
      width: 87%;
      float: right;
      height: 100%;

      b {
        display: block;
        position: relative;
        margin-bottom: 0.3rem;
        font-size: 0.28rem;
        // line-height: 0.3rem;
        font-weight: 500;
        text-align: left;
        display: flex;

        .ysj {
          font-size: 0.2rem;
          color: #fff;
          background: #0058b1;
          padding: 0.07rem 0.15rem;
          border-radius: 0.05rem;
          margin-right: 0.3rem;
        }
      }

      span.conn {
        cursor: pointer;
        display: block;
        text-indent: 2em;
        line-height: 0.3rem;
        font-size: 0.2rem;
        color: #666;

        >span {
          color: #0158b1;
        }
      }
    }
  }
}

#Page {
  margin-top: 0.3rem;
  padding-right: 2rem;
}
</style>